export const products = [
  {
    id: 'p1',
    name: 'MacBook Pro 14" M3',
    category: 'Laptops',
    price: '$1,999',
    specs: ['Apple M3 Pro chip', '18GB Unified Memory', '512GB SSD', '14.2" Liquid Retina XDR'],
    image: 'https://images.unsplash.com/photo-1611186871348-b1ce696e52c9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    badge: 'Best Seller',
  },
  {
    id: 'p2',
    name: 'Dell XPS 15 Ultrabook',
    category: 'Laptops',
    price: '$1,749',
    specs: ['Intel Core i7-13700H', '16GB DDR5 RAM', '1TB NVMe SSD', '15.6" OLED Touch'],
    image: 'https://images.pexels.com/photos/93405/pexels-photo-93405.jpeg?auto=compress&cs=tinysrgb&w=800',
    badge: '',
  },
  {
    id: 'p3',
    name: 'ASUS ROG Gaming Laptop',
    category: 'Gaming',
    price: '$2,299',
    specs: ['AMD Ryzen 9', 'RTX 4070 8GB', '32GB DDR5 RAM', '240Hz QHD Display'],
    image: 'https://images.unsplash.com/photo-1630794180018-433d915c34ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    badge: 'Top Rated',
  },
  {
    id: 'p4',
    name: 'Apple iMac 24" M3',
    category: 'Desktops',
    price: '$1,499',
    specs: ['Apple M3 chip', '8-core GPU', '256GB SSD', '4.5K Retina Display'],
    image: 'https://images.unsplash.com/photo-1587831990711-23ca6441447b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    badge: '',
  },
  {
    id: 'p5',
    name: 'HP Spectre x360 Convertible',
    category: 'Laptops',
    price: '$1,349',
    specs: ['Intel Core Ultra 7', '16GB RAM', '512GB SSD', '13.5" 3K2K OLED'],
    image: 'https://images.unsplash.com/photo-1541807084-5c52b6b3adef?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    badge: '',
  },
  {
    id: 'p6',
    name: 'Custom Pro Workstation',
    category: 'Desktops',
    price: '$2,899',
    specs: ['Intel Core i9-14900K', 'RTX 4080 16GB', '64GB DDR5 RAM', '2TB NVMe SSD'],
    image: 'https://images.unsplash.com/photo-1679240360999-92f46d4781b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    badge: 'Power User',
  },
  {
    id: 'p7',
    name: 'Lenovo ThinkPad X1 Carbon',
    category: 'Laptops',
    price: '$1,599',
    specs: ['Intel Core Ultra 7', '16GB LPDDR5', '1TB SSD', '14" WUXGA Anti-glare'],
    image: 'https://images.unsplash.com/photo-1603302576837-37561b2e2302?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    badge: '',
  },
  {
    id: 'p8',
    name: 'Razer Blade 16 Gaming',
    category: 'Gaming',
    price: '$3,199',
    specs: ['Intel Core i9', 'RTX 4090 16GB', '32GB DDR5', '16" Dual-Mode Mini LED'],
    image: 'https://images.unsplash.com/photo-1611078489935-0cb964de46d6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    badge: 'Premium',
  },
];

export const productCategories = ['All', 'Laptops', 'Desktops', 'Gaming'];

export const planOptions = ['1 Year Support', '2 Year Support', 'Lifetime Support'];

export const timeSlots = [
  '09:00 AM', '10:00 AM', '11:00 AM', '12:00 PM',
  '01:00 PM', '02:00 PM', '03:00 PM', '04:00 PM', '05:00 PM',
];
